import { Badge } from '@/shared/components/ui/badge'
import { CHAT_COPY } from '@/entities/chat'
import type { ChatStreamStatus } from '@/shared/realtime/chatEventStream'

export function StreamPill({ status, onRetry }: { status: ChatStreamStatus; onRetry: () => void }) {
  if (status === 'live') {
    return (
      <Badge tone="ok" dot className="h-5 px-2 text-[11px]">
        {CHAT_COPY.live}
      </Badge>
    )
  }

  if (status === 'connecting') {
    return (
      <Badge tone="neutral" dot className="h-5 px-2 text-[11px]">
        {CHAT_COPY.connecting}
      </Badge>
    )
  }

  return (
    <button type="button" onClick={onRetry} className="inline-flex">
      <Badge tone={status === 'ended' ? 'bad' : 'warn'} dot className="h-5 px-2 text-[11px]">
        {CHAT_COPY.streamDown}
      </Badge>
    </button>
  )
}
